module.exports = __webpack_public_path__ + "fa-regular-400.94e84d7efab99a5bb706.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/webfonts/fa-regular-400.woff2
// module id = ../../../../../src/assets/fonts/webfonts/fa-regular-400.woff2
// module chunks = styles